export function encryptCode(data){
    var CryptoJS = require("crypto-js");
    var secretKey = CryptoJS.enc.Utf8.parse("blocksquareretri"); // 16바이트 키
    var iv = CryptoJS.enc.Utf8.parse("retriblocksquare"); // 16바이트 IV

    var encrypted = CryptoJS.AES.encrypt(data, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
    }).toString();
    // console.log(encrypted);
    return encrypted
}